import { render, staticRenderFns } from "./Reservations.template.vue?vue&type=template&id=0ca730a6&scoped=true&"
var script = {}
import style0 from "./Reservations.template.vue?vue&type=style&index=0&id=0ca730a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca730a6",
  null
  
)

export default component.exports